import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';
import { useMobileMediaQuery } from 'Utils/mediaQuery';

const mobileSize = 14;
const desktopSize = 22;

const LeftArrowIcon = ({
  round,
  containerColor,
  containerSize,
  color,
  size,
  onClick,
  className,
}) => {
  const isMobile = useMobileMediaQuery();

  const iconSize = size || isMobile ? mobileSize : desktopSize;

  return (
    <WithIconRounded
      round={round}
      containerColor={containerColor}
      containerSize={containerSize}
      className={className}
      onClick={onClick}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.43737 9.66673H21.6667V12.3334H5.43737L12.5894 19.4854L10.704 21.3707L0.333374 11.0001L10.704 0.629395L12.5894 2.51473L5.43737 9.66673Z"
          fill={color}
        />
      </svg>
    </WithIconRounded>
  );
};

LeftArrowIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

LeftArrowIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#18223D',
  containerColor: undefined,
  containerSize: 34,
  onClick: null,
  round: false,
  size: null,
};

export default LeftArrowIcon;
